import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_HOST } from "../../constants";
import { getCookie } from "../../utils/cookieUtil";

function BbsVoteButton({ document_id, likeCount = 0, dislikeCount = 0 }) {
  const [likes, setLikes] = useState(likeCount);
  const [dislikes, setDislikes] = useState(dislikeCount);
  const [pendingVote, setPendingVote] = useState(null);

  useEffect(() => {
    setLikes(likeCount);
    setDislikes(dislikeCount);
  }, [likeCount, dislikeCount]);

  const handleVote = (isUpvote) => {
    if (pendingVote !== null) return;
    setPendingVote(isUpvote);
    const csrfToken = getCookie("csrftoken");
    axios
      .post(
        `${API_HOST}/api/bbs/${document_id}/vote/`,
        { is_upvote: isUpvote },
        {
          headers: {
            "X-CSRFToken": csrfToken,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      )
      .then((response) => {
        const data = response?.data;
        if (data?.like_count !== undefined) {
          setLikes(data.like_count);
        } else {
          setLikes((prev) => prev + (isUpvote ? 1 : 0));
        }
        if (data?.dislike_count !== undefined) {
          setDislikes(data.dislike_count);
        } else {
          setDislikes((prev) => prev + (!isUpvote ? 1 : 0));
        }
      })
      .catch((error) => {
        console.error("Error updating vote:", error.response?.data);
      })
      .finally(() => setPendingVote(null));
  };

  return (
    <div className="flex w-full flex-wrap items-center justify-center gap-3">
      <button
        type="button"
        onClick={() => handleVote(true)}
        className={`flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-semibold transition ${
          pendingVote === true
            ? "border-brand-300 bg-brand-400/20 text-brand-100"
            : "border-white/10 bg-white/5 text-ink-200 hover:border-brand-300/60 hover:text-white"
        }`}
      >
        ▲ 추천
        <span className="rounded-full bg-white/10 px-2 py-0.5 text-xs">{likes}</span>
      </button>
      <button
        type="button"
        onClick={() => handleVote(false)}
        className={`flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-semibold transition ${
          pendingVote === false
            ? "border-accent-400/60 bg-accent-400/20 text-accent-100"
            : "border-white/10 bg-white/5 text-ink-200 hover:border-accent-400/60 hover:text-white"
        }`}
      >
        ▼ 비추천
        <span className="rounded-full bg-white/10 px-2 py-0.5 text-xs">{dislikes}</span>
      </button>
    </div>
  );
}

export default BbsVoteButton;
